import {handleLogout} from "components/utils";
import React, {useEffect, useRef, useState} from 'react';
import axios from "axios";
import {CaseHeaderView} from "../../subCategories/CaseHeaderView";
import {Button} from "react-bootstrap";
import ReactToPrint from "react-to-print";

export const ConsentFormPrintView = (props: { id: string, entityQr: string, caseDetails: any, dischargeDate: any }) => {
    const [content, setContent] = useState(null);
    let componentRef = useRef(null);
    useEffect(() => {
        axios.get('/api/backend/form/template/fetch/' + props.id + '/' + props.caseDetails.uhid)
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                if (resp.data) {
                    setContent(resp.data.content)
                }
            })
            .catch(err => {
                console.error(err);
                if (err.response && err.response!.status && err.response!.status === 403) {
                    handleLogout()
                }
            })
    }, [props.id])

    function getItemForm() {
        return <>
            <div dangerouslySetInnerHTML={{__html: content}}/>
        </>;
    }


    return (
        <>
            <div ref={componentRef} className="m-4">
                <CaseHeaderView caseDetails={props.caseDetails} dischargeDate={props.dischargeDate}/>
                {getItemForm()}
            </div>
            <div className="mx-4">
            <ReactToPrint
                trigger={() => <Button
                    className="btn btn-outline-secondary text-secondary bg-white btn-sm rounded-form"
                >&#128424; Print Form</Button>}
                content={() => componentRef.current}/>
            </div>
        </>
    );
};
